import React, {useEffect, useState} from 'react';
import {useFetching} from "../hooks/useFetching";
import OrderRAPI from "../API/OrderRAPI";
import OrderTR from "../components/Order/OrderTR";
import '../css/OrderTR.module.css';
import {useNavigate} from "react-router-dom";
import {useTitle} from "../hooks/useTitle";

const Orders = () => {
    useTitle('Заказы')
    const navigate = useNavigate();

    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('all')

    const [orders, setOrders] = useState<any[]>([])
    const [page, setPage] = useState(1)
    const [pagination, setPagination] = useState({
        cur: 1,
        max: 10
    })

    const [fetchData, isLoading, errorData] = useFetching(async () => {
        const res = await OrderRAPI.getAll(search, page, status)
        if (res.list.length === 1 && search !== '') {
            navigate('/orders/' + res.list[0].id)
        } else {
            setOrders(res.list)
            setPagination(res.pagination)
        }
    })

    const searchInput = async (event: any) => {
        if (event.key === "Enter") {
            setPage(1)
            setSearch(event.target.value)
        }
    }

    const rows = [];

    for (let i = 1; i <= pagination.max; i++) {
        if (Math.abs(pagination.cur - i) <= 5 || i == pagination.max || i == 1) {
            if (Math.abs(pagination.cur - i) == 5) {
                rows.push(<li><a>...</a></li>);
            } else {
                rows.push(<li className={i == page ? 'active cp' : ' cp'} onClick={() => setPage(i)}><a>{i}</a></li>);
            }
        }
    }
    useEffect(() => {
        fetchData()
    }, [search, page, status])

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="d-flex flex-wrap justify-content-start">
                    <div className="d-flex" style={{maxWidth: '150px'}}>
                        <input type="text" className="form-control" placeholder="Поиск по заказам" style={{height: '41px'}} onKeyPress={(e) => searchInput(e)}/>
                    </div>
                    <div className="d-flex ms-3" style={{maxWidth: '150px'}}>
                        <select value={status} onChange={e => setStatus(e.target.value)} className="form-control" style={{height: '41px'}} placeholder="Фильтр по статусам">
                            <option value="all">Все</option>
                            <option value="process">В работе</option>
                            <option value="waiting">Ждут выдачи</option>
                            <option value="closed">Закрытые</option>
                            <option value="almost_closed">Почти закрытые</option>
                        </select>
                    </div>
                    <div className="ms-3">
                        <button className="btn btn-icon bg-gradient-primary" onClick={() => navigate('/orders/new/')}>
                            Новый заказ
                        </button>
                    </div>
                    <div className="dataTable-wrapper ms-auto">
                        <div className="dataTable-bottom">
                            <nav className="dataTable-pagination">
                                <ul className="dataTable-pagination-list">
                                    {rows}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div className="card dataTable-wrapper">
                    <div className="table-responsive">
                        <table className="table align-items-center mb-0">
                            <thead>
                            <tr>
                                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Заказ</th>
                                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Статус</th>
                                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Клиент</th>
                                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Изделия</th>
                                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Сумма заказа</th>
                            </tr>
                            </thead>
                            <tbody>
                            {orders.length > 0 &&
                                orders.map((order) =>
                                <OrderTR key={order.id} order={order}/>
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="dataTable-bottom mt-4">
                        <nav className="dataTable-pagination">
                            <ul className="dataTable-pagination-list">
                                {rows}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Orders;